export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST'
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCCESS'
export const ORDER_CREATE_FAIL = 'ORDER_CREATE_FAIL'

export const ORDER_FEED_REQUEST = 'ORDER_FEED_REQUEST'
export const ORDER_FEED_SUCCESS = 'ORDER_FEED_SUCCESS'
export const ORDER_FEED_FAIL = 'ORDER_FEED_FAIL'
export const ORDER_FEED_RESET = 'ORDER_FEED_RESET'

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST'
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS'
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL'
export const ORDER_DETAILS_RESET = 'ORDER_DETAILS_RESET'

export const ORDER_FEED_DISABLE_SHOW_MORE = 'ORDER_FEED_DISABLE_SHOW_MORE'


export const ORDER_CHANGE_STATUS_REQUEST = 'ORDER_CHANGE_STATUS_REQUEST'
export const ORDER_CHANGE_STATUS_SUCCESS = 'ORDER_CHANGE_STATUS_SUCCESS'
export const ORDER_CHANGE_STATUS_FAIL = 'ORDER_CHANGE_STATUS_FAIL'

